// extracted by mini-css-extract-plugin
export var attachment = "_on-a";
export var emailContainer = "_on-4";
export var emailContentPaddedContainer = "_on-b";
export var emailHeader = "_on-6";
export var emailIframe = "_on-3";
export var emailInfoIcon = "_on-9";
export var emailShortenedSummary = "_on-e";
export var infoDropdown = "_on-0";
export var infoRowBoundedContent = "_on-d";
export var internal = "_on-5";
export var merchant = "_on-8";
export var messageInputContainer = "_on-h";
export var normal = "_on-7";
export var replyCard = "_on-f";
export var subtleButton = "_on-1";
export var subtleButtonIconContainer = "_on-2";
export var toggleViewRepliesButton = "_on-c";
export var wrappingText = "_on-g";